import React, { useEffect, memo, useState, useRef } from 'react';
import './index.less';
import { IPredictionScoreExamPointDetail } from '@/types';
import SafeHTML from '@/components/safe-html';

interface IProps {
    detailData: IPredictionScoreExamPointDetail;
}

const ExamPointDefinition = ({ detailData }: IProps) => {
    return (
        <div className="sub-tiku__exam-point-definition">
            <div className="sub-tiku__exam-point-definition-header">
                <div className="sub-tiku__exam-point-definition-header-title">
                    <span>{detailData.title}</span>
                </div>
                {detailData.important === 4 && (
                    <div className="sub-tiku__exam-point-definition-header-extra">
                        <div className="sub-tiku__exam-point-definition-tag">{detailData.importantDesc}</div>
                    </div>
                )}
            </div>
            {detailData.definition && (
                <div className="sub-tiku__exam-point-definition-content">
                    <div className="sub-tiku__exam-point-definition-content-suffix">定义: </div>
                    <div className="sub-tiku__exam-point-definition-content-text">
                        <SafeHTML html={detailData.definition} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default memo(ExamPointDefinition);
